import React, { useState } from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import TableSettingsModal from "../WidgetsSettings/Table/TableSettingsModal";
import { TableController } from "../../BP2Components/Table/TableController";
import TableFilters from "./TableComponents/TableFilter/TableFiltersController";
import { getSerieSetting } from "./TableComponents/TableFilter/TableFIlterScripts";
import { TableListProvider } from "../../../context/TableListContext/TableListContext";
import MassActions from "./TableComponents/MassActions/MassActions";

const TableWidget = ({ value, role, data }) => {
   const [widgetSettings, setWidgetSettings] = useState(value);
   const listId = String(getSerieSetting("dataId", widgetSettings) ?? "");

   const activeSerie = widgetSettings?.tableSeries?.find(
      (serie) => String(serie.dataId) === String(listId),
   );

   const defaultFilterIdFromSettings = activeSerie?.defaultFilterId ?? false;

   return (
      <>
         <div className="widget-button">
            <Widget
               styleName="gx-m-0"
               bgColor={widgetSettings.backgroundColourHex}
               className={`${widgetSettings?.hideWidgetBorder && "hidden-widget-background"}`}
               role={role}
               extra={
                  (role === "OWNER" || role === "MODERATOR") && (
                     <SettingsModal
                        widgetId={widgetSettings.id}
                        widgetName={widgetSettings.name}
                        icon="setting"
                        deleteIcon="true"
                        children={
                           <TableSettingsModal
                              value={widgetSettings}
                              data={data}
                              setWidgetSettings={setWidgetSettings}
                           />
                        }
                     />
                  )
               }
            >
               <TableListProvider initialWidgetData={widgetSettings}>
                  {widgetSettings?.showListFilters && (
                     <>
                        <TableFilters
                           value={widgetSettings}
                           listId={listId}
                           defaultFilterIdFromSettings={defaultFilterIdFromSettings}
                           setWidgetSettings={setWidgetSettings}
                        />
                        <MassActions listId={listId} />
                     </>
                  )}
                  <TableController
                     itemsPerPage={getSerieSetting("itemsPerPage", widgetSettings)}
                     showPager={true}
                     splitForPages={false}
                     customGUID={widgetSettings.id}
                     withCheckbox={widgetSettings?.showListFilters}
                     listId={listId}
                     showListFilters={!!widgetSettings?.showListFilters}
                     defaultFilterIdFromSettings={defaultFilterIdFromSettings}
                     allowInlineEdit={!!widgetSettings?.edit}
                  ></TableController>
               </TableListProvider>
            </Widget>
         </div>
      </>
   );
};

export default TableWidget;
